import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {lastValueFrom, Observable} from 'rxjs';
import {UserInfoQuery} from '../elf-store/user-info/user-info.query';
import {AuthService} from 'src/app/auth/shared/services/auth.service';
import {userInfoStore} from '../elf-store/user-info/user-info.store';

@Injectable({
  providedIn: 'root',
})
export class RegulationModeOnlyGuard {
  private router = inject(Router);
  private userQuery = inject(UserInfoQuery);
  private authService = inject(AuthService);
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const allowedUrls = ['/regulation', '/settings', '/team'];
    const isAllowedUrl = allowedUrls.some(url => state.url.startsWith(url));

    const isEnabled = await this.isCanBeActivated();

    if (!isAllowedUrl && !isEnabled) {
      this.router.navigate(['/regulation']);
    }

    return isAllowedUrl || isEnabled;
  }

  async isCanBeActivated() {
    if (!userInfoStore.getValue().userInfo.hasOwnProperty('regulation_tracker_mode_only')) {
      await lastValueFrom(this.authService.loadUserOrTeamDataBasedOnSwitch());
    }
    return !userInfoStore.getValue().userInfo?.regulation_tracker_mode_only;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }
}
